import React from 'react'

import cx from 'classnames'

import {
  FilterableEntity,
  FilterConfigAndAvailableValues,
  FilterValues,
  FilterValueType,
  getFilterConfig
} from 'utils/filters'

import FilterRow from './FilterRow'

import utilityStyles from '../../../styles/utility.module.css'
import styles from '../styles.module.css'

interface FilterGroupProps {
  groupIndex: number
  filters: FilterValues[]
  filterConfiguration: FilterConfigAndAvailableValues[]
  calendarOpenDirection?: 'up' | 'down'
  showFormValidation?: boolean
  isInlineCard?: boolean
  handleChangeFilterType: (value: any, filterIndex: number, groupIndex: number) => void
  handleChangeFilterOperator: (value: any, filterIndex: number, groupIndex: number) => void
  handleChangeFilterValue: (value: any, filterIndex: number, groupIndex: number) => void
  handleRemoveFilter: (filterIndex: number, groupIndex: number) => void
  searchValue: string
  setSearchValue: (value: string) => void
}

const getSelectedValues = (
  filterValue: FilterValues,
  filterConfig: FilterConfigAndAvailableValues | null
) => {
  if (FilterableEntity.LAST_TOUCHED === filterValue.filterType) {
    return filterValue.values
  }

  if (
    filterValue.valueType === FilterValueType.NUMBER ||
    filterValue.attributeType === FilterValueType.NUMBER
  ) {
    return filterValue.values
  }

  if (typeof filterValue.values === 'object' && filterValue.values !== null) {
    return filterValue.values
  }

  if (!filterValue?.values) {
    return []
  }

  return filterValue.values.map(({ label, value }: Record<string, string>) => {
    if (
      value === label &&
      (FilterableEntity.ACCOUNT_OWNERS === filterValue.filterType ||
        filterConfig?.attributeType === 'TEAMMEMBER')
    ) {
      return {
        label: 'Deleted user',
        value: value
      }
    }

    return {
      label,
      value
    }
  })
}

const FilterGroup: React.FC<FilterGroupProps> = ({
  groupIndex,
  filters,
  filterConfiguration,
  calendarOpenDirection,
  showFormValidation,
  handleChangeFilterType,
  handleChangeFilterOperator,
  handleChangeFilterValue,
  handleRemoveFilter,
  searchValue,
  setSearchValue
}) => {
  return (
    <div className={styles.filtersContainer}>
      <div className={styles.andBlock}>
        <div className={cx(styles.andStyle, utilityStyles.semiBoldWeight)}>AND</div>
      </div>
      <div className={styles.filterSubContainer}>
        {filters.map((filterValue, filterIndex) => {
          const filterConfig = getFilterConfig(filterValue, filterConfiguration)

          const selectedValues = getSelectedValues(filterValue, filterConfig)
          return (
            filterConfig && (
              <FilterRow
                key={filterIndex}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                filter={filterConfig}
                filterConfiguration={filterConfiguration}
                filters={filters}
                comparator={filterValue.operator ?? filterConfig.operators[0]}
                selectedValues={selectedValues}
                showFormValidation={showFormValidation}
                calendarOpenDirection={calendarOpenDirection}
                onChangeFilterType={(value: any) =>
                  handleChangeFilterType(value, filterIndex, groupIndex)
                }
                onChangeComparator={(value: any) =>
                  handleChangeFilterOperator(value, filterIndex, groupIndex)
                }
                onChangeValue={(value: any) =>
                  handleChangeFilterValue(value, filterIndex, groupIndex)
                }
                onRemoveFilter={() => handleRemoveFilter(filterIndex, groupIndex)}
              />
            )
          )
        })}
      </div>
    </div>
  )
}

export default FilterGroup
